import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FunnelChart } from '@/components/analytics/FunnelChart';
import { FunnelDrilldown } from '@/components/analytics/FunnelDrilldown';

const DEFAULT_FROM = (() => {
  const d = new Date();
  d.setDate(d.getDate() - 30);
  return d.toISOString().split('T')[0];
})();
const DEFAULT_TO = new Date().toISOString().split('T')[0];

export function FunnelView() {
  const [searchParams] = useSearchParams();
  const dateFrom  = searchParams.get('from')      ?? DEFAULT_FROM;
  const dateTo    = searchParams.get('to')         ?? DEFAULT_TO;
  const highlight = searchParams.get('highlight')  ?? undefined;

  const [selectedStage, setSelectedStage] = useState<string | null>(null);

  return (
    <div className="space-y-6">
      <FunnelChart
        dateFrom={dateFrom}
        dateTo={dateTo}
        onStageClick={setSelectedStage}
        highlightId={highlight}
      />
      <FunnelDrilldown
        stage={selectedStage}
        onClose={() => setSelectedStage(null)}
        dateFrom={dateFrom}
        dateTo={dateTo}
      />
    </div>
  );
}
